import { CONFIG_CONSTANTS, ERROR_CONSTANTS, PRODUCT_CONSTANTS } from '../actionTypes'
import { apiService } from '../../store/middleware/service'
import { alertActions, languageAction } from '../../store/actions'
import {
	APP_HELPER,
	ANALYTICS_HELPER,
	HELPER,
	CONSTANTS,
	ROUTE_CONSTANTS,
	ERROR_MSGS,
	REDIRECTION_RULE,
	PRODUCT_HELPER,
} from '../../utils'
import { cartActions } from './cartActions'
import { store } from '..'

export const configActions = {
	CATALOG_CONFIGURATION,
	CUSTOM_CATALOG_DOMAIN,
	EMPTY_CATALOG_CART_ITEMS,
	EMPTY_CATALOG_WITHOUT_PRODUCT_JOURNEY,
	STORE_CONFIGURATION,
	STORE_NOT_FOUND,
	SET_DEFAULT_APP_STATE,
	SET_CATALOG_VISIBLE_PRODUCT,
	UPDATE_CURRENT_PRODUCT_PAGE,
	LOAD_MORE_PRODUCTS,
}

function LOAD_MORE_PRODUCTS() {
	return (dispatch) => {
		dispatch(request())
	}
	function request() {
		return { type: PRODUCT_CONSTANTS.LOAD_MORE_PRODUCTS }
	}
}

function CATALOG_CONFIGURATION(history) {
	return (dispatch, getState) => {
		// grab current state
		const state = getState()
		const { catalog_journey_settings, catalogue_key } = state.config
		const { product_items } = catalog_journey_settings
		dispatch(request())
		apiService
			.catalogueConfiguration(catalogue_key)
			.then((response) => {
				const responseStatus = response?.status
				if (!HELPER.isEmpty(responseStatus) && responseStatus === CONSTANTS.HTTP_RESPONSE.SUCCESS) {
					let dataList = response?.data
					dataList.products = PRODUCT_HELPER.FORMAT_PRODUCT_ARRAY(dataList)
					dataList.categories = PRODUCT_HELPER.FORMAT_CATEGORIES(dataList, catalog_journey_settings)
					dataList.categories_with_products = PRODUCT_HELPER.FORMAT_PRODUCT_WITH_CATEGORIES(
						dataList,
						catalog_journey_settings
					)
					let productFound = {}
					if (!HELPER.isEmpty(product_items) && !HELPER.isEmpty(dataList.products)) {
						const products = dataList.products
						product_items.map((catalog_product_item) => {
							productFound = products.find((product) => {
								return parseInt(product.id) === parseInt(catalog_product_item)
							})
							return true
						})
					}
					if (!HELPER.isEmpty(product_items) && productFound === undefined) {
						productFound = {}
						const error_message = APP_HELPER.CHECK_LTR_LANG()
							? ERROR_MSGS.EN.INVALID_PRODUCT
							: ERROR_MSGS.UR.INVALID_PRODUCT
						dispatch(alertActions.warning(error_message, CONSTANTS.ERROR_TYPE.TOAST))
						setTimeout(() => {
							dispatch(alertActions.clear())
						}, 2000)
						dispatch(cartActions.REMOVE_CART_ITEMS_FROM_CATALOG_JOURNEY_SETTINGS())
					} else {
						if (productFound?.user_journey === CONSTANTS.PRODUCT_JOURNEYS.CATALOG_WITHOUT_PRODUCT) {
							dispatch(catalog_without_product_journey_settings(true, productFound))
						}
						const { maximum_purchase_limit } = dataList?.metadata
						REDIRECTION_RULE.CATALOG_REDIRECTION_RULE(maximum_purchase_limit, productFound, history)
					}
					dispatch(success(dataList, productFound))
				}
			})

			.catch((error) => {
				dispatch(failure(error))
				dispatch(configActions.STORE_NOT_FOUND(catalogue_key, history))
			})
	}

	function catalog_without_product_journey_settings(
		set_catalog_without_product,
		catalog_without_product_item
	) {
		let response = { set_catalog_without_product, catalog_without_product_item }
		return { type: CONFIG_CONSTANTS.SET_CATALOG_WITHOUT_PRODUCT_JOURNEY, response }
	}
	function request() {
		return { type: CONFIG_CONSTANTS.STORE_CATALOG_INFO_REQUEST }
	}
	function success(data, productFound) {
		return {
			type: CONFIG_CONSTANTS.STORE_CATALOG_INFO_SUCCESS,
			response: { data, cart_items: productFound },
		}
	}
	function failure(error) {
		return { type: CONFIG_CONSTANTS.STORE_CATALOG_INFO_FAILURE, error }
	}
}

function CUSTOM_CATALOG_DOMAIN(catalogue_key) {
	return (dispatch) => {
		dispatch(request(catalogue_key))
	}
	function request(catalogue_key) {
		return { type: CONFIG_CONSTANTS.CUSTOM_CATALOG_DOMAIN_DEFAULT, response: { catalogue_key } }
	}
}

function EMPTY_CATALOG_CART_ITEMS() {
	return (dispatch) => {
		dispatch(request())
	}
	function request() {
		return { type: CONFIG_CONSTANTS.SET_APP_SETTINGS_TO_DEFAULT }
	}
}

function EMPTY_CATALOG_WITHOUT_PRODUCT_JOURNEY() {
	return (dispatch) => {
		dispatch(request())
	}
	function request() {
		return { type: CONFIG_CONSTANTS.EMPTY_CATALOG_WITHOUT_PRODUCT_JOURNEY }
	}
}

function SET_CATALOG_VISIBLE_PRODUCT(params, concat = false) {
	//  const state = store.getState();
	// const { products, productsPerPage, productsCurrentPage, } = params ? params : state.inventory;
	const { products, productsPerPage, productsCurrentPage } = params
	return (dispatch) => {
		if (!HELPER.isEmpty(products) && products.length > 0) {
			const indexOfLastProduct = productsCurrentPage * productsPerPage
			const indexOfFirstProduct = indexOfLastProduct - productsPerPage
			const totalPages = Math.ceil(products.length / productsPerPage)
			const visibleProducts = products.slice(indexOfFirstProduct, indexOfLastProduct)
			dispatch(request(visibleProducts, totalPages))
		}
	}

	function request(products, totalPages) {
		return {
			type: PRODUCT_CONSTANTS.SET_CATALOG_VISIBLE_PRODUCT_SUCCESS,
			response: {
				visible_products: products,
				total_pages: totalPages,
				concat,
				productsCurrentPage,
			},
		}
	}
}

function SET_DEFAULT_APP_STATE() {
	return () => {
		// dispatch(request());
	}
	// function request() {
	// return { type: CONFIG_CONSTANTS.SET_APP_SETTINGS_TO_DEFAULT };
	// }
}

function STORE_NOT_FOUND(store_name, history) {
	return (dispatch) => {
		const error_message = {
			type: ERROR_CONSTANTS.ERROR,
			status: CONSTANTS.HTTP_RESPONSE.NOT_FOUND,
			message: APP_HELPER.CHECK_LTR_LANG()
				? ERROR_MSGS.EN.INVALID_STORE
				: ERROR_MSGS.UR.INVALID_STORE,
			description: APP_HELPER.CHECK_LTR_LANG() ? ERROR_MSGS.EN.NOT_FOUND : ERROR_MSGS.UR.NOT_FOUND,
		}
		ANALYTICS_HELPER._triggerEvent(ANALYTICS_HELPER.CATEGORY.ERROR, {
			action: ERROR_MSGS.EN.ACCESS_FORBIDDEN + ' - ' + store_name,
			label: error_message?.message,
			properties: {},
		})
		dispatch(request(error_message))
		history.push({
			pathname: ROUTE_CONSTANTS.ERROR_PAGE,
		})
		// window.location.reload();
	}

	function request(error) {
		return { type: ERROR_CONSTANTS.ERROR, error }
	}
}

function STORE_CONFIGURATION(store_name, product_id, history) {
	return (dispatch, getState) => {
		// grab current state
		const state = getState()
		const { last_updated, config_load_count, catalogue_key } = state.config
		const { allProducts } = state.inventory
		const { locale } = state.Intl

		const products = allProducts
		dispatch(request(store_name))
		apiService
			.storeConfiguration(store_name)
			.then((response) => {
				const responseStatus = response?.status
				let cart_items = {}
				if (!HELPER.isEmpty(responseStatus) && responseStatus === CONSTANTS.HTTP_RESPONSE.SUCCESS) {
					let dataList = response?.data
					if (dataList?.metadata?.default_lang && config_load_count === 0 && locale !== 'ur') {
						dispatch(languageAction.updateLanguageLocale(dataList?.metadata?.default_lang))
					}
					if (
						dataList?.last_updated > last_updated.new ||
						last_updated.new === 0 ||
						catalogue_key !== store_name
					) {
						dispatch(success(dataList, product_id))
					} else {
						if (!HELPER.isEmpty(product_id) && !HELPER.isEmpty(products)) {
							cart_items = products.find((product) => {
								return product.id === parseInt(product_id)
							})
							if (cart_items === undefined) {
								const error_message = APP_HELPER.CHECK_LTR_LANG()
									? ERROR_MSGS.EN.INVALID_PRODUCT
									: ERROR_MSGS.UR.INVALID_PRODUCT
								dispatch(alertActions.warning(error_message, CONSTANTS.ERROR_TYPE.TOAST))
								setTimeout(() => {
									dispatch(alertActions.clear())
								}, 2000)
								dispatch(cartActions.REMOVE_CART_ITEMS_FROM_CATALOG_JOURNEY_SETTINGS())
							} else {
								dataList.product_id = product_id
								if (
									cart_items?.user_journey === CONSTANTS.PRODUCT_JOURNEYS.CATALOG_WITHOUT_PRODUCT
								) {
									dispatch(catalog_without_product_journey_settings(true, cart_items))
								}
								dataList.cart_items = REDIRECTION_RULE.CATALOG_REDIRECTION_RULE(cart_items, history)
							}
							dispatch(updated_success(dataList, products))
						} else {
							dataList.product_id = product_id
							dataList.cart_items = cart_items
							dispatch(updated_success(dataList, products))
						}
					}
				}
			})
			.catch((error) => {
				dispatch(failure(error))
				dispatch(configActions.STORE_NOT_FOUND(store_name, history))
			})
	}

	function catalog_without_product_journey_settings(
		set_catalog_without_product,
		catalog_without_product_item
	) {
		let response = { set_catalog_without_product, catalog_without_product_item }
		return { type: CONFIG_CONSTANTS.SET_CATALOG_WITHOUT_PRODUCT_JOURNEY, response }
	}

	function request(store_slug) {
		return { type: CONFIG_CONSTANTS.STORE_CONFIGURATION_REQUEST, catalogue_key: store_slug }
	}
	function success(data, product_id, cart_items) {
		return {
			type: CONFIG_CONSTANTS.STORE_CONFIGURATION_SUCCESS,
			response: { data, product_id, cart_items },
		}
	}
	function updated_success(data, products) {
		return {
			type: CONFIG_CONSTANTS.UPDATED_STORE_CONFIGURATION_SUCCESS,
			response: { data, product_list: products },
		}
	}
	function failure(error) {
		return { type: CONFIG_CONSTANTS.STORE_CONFIGURATION_FAILURE, error }
	}
}

function UPDATE_CURRENT_PRODUCT_PAGE(params) {
	const state = store.getState()
	const { products, productsPerPage, productsCurrentPage } = params ? params : state.inventory
	return (dispatch) => {
		dispatch(success(productsCurrentPage))
		const visibleProductParams = {
			products: products,
			productsPerPage: productsPerPage,
			productsCurrentPage: productsCurrentPage + 1,
		}
		dispatch(configActions.SET_CATALOG_VISIBLE_PRODUCT(visibleProductParams, true))
	}

	function success(productsCurrentPage) {
		return {
			type: PRODUCT_CONSTANTS.UPDATE_CURRENT_PRODUCT_PAGE,
			response: { productsCurrentPage: productsCurrentPage + 1 },
		}
	}
}
